export class NewsComment {
  public id: number;
  public newsId: number;
  public parentCommentId: number;
  public authorId: number;
  public createDate: Date;
  public authorName: string;
  public authorEmail: string;
  public commentText: string;
}



// WEBPACK FOOTER //
// ./src/app/modules/common-main/components/news-layout/model/news-comment.ts